import IntegerInput from '@/fields/IntegerInput.vue'
import BasicSelect from '@/fields/BasicSelect.vue'
import TextBox from '@/fields/TextBox.vue'
import DateTimeSelector from '@/fields/DateTimeSelector.vue'
import JsonFormsEditor from '@/fields/JsonFormsEditor.vue'
import htmlEditor from '@/HtmlEditor.vue'


// A map from 'hr_type' to the form field widget
const CUSTOMFIELD_WIDGETS = {
    'Date': DateTimeSelector,
    'Integer': IntegerInput,
    'Text': TextBox,
    'Rich Text': htmlEditor,
    'Choice': BasicSelect,
    'Structured Data (JSON)': JsonFormsEditor
}

const ErrorCodes = {
    'unauthorised': 401,
    'forbidden': 403,
}


export default {
    CUSTOMFIELD_WIDGETS: CUSTOMFIELD_WIDGETS,
    ErrorCodes: ErrorCodes
}

